import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW7402Model } from "../kymw7402.model";
import { RememberGoodsInfoModel } from "../vo/remember-goods-info.model";
import { KYMW00Model } from "../../../../commons/kymw00/kymw00.model";

/**
 * 忘れず注文商品情報更新
 * 
 */
@Injectable()
export class UpdateRememberGoodsInfoService extends PlessJsonResponderSub<any> {

  private model: KYMW7402Model;
  private vo: RememberGoodsInfoModel;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
    protected kymw00Model: KYMW00Model,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   * 
   */
  private getBody() {
    return new PlessRequest({
      update: {
        RememberGoodsInfo: {
          parameter: {
            RememberGoodsId: this.vo.rememberGoodsId,
            RememberGoodsStatus: this.vo.rememberGoodsStatus,
            ItemCode: this.vo.itemCode,
            OrderNum: this.vo.orderNum,
            OrderChangeOrderNum: this.vo.orderChangeOrderNum,
            IncreaseGoods: this.vo.increaseGoods,
            RememberCategoryCode: this.vo.rememberCategoryCode,
            OrderReceptionStartCatalog: this.vo.orderReceptionStartCatalog,
            OrderReceptionEndCatalog: this.vo.orderReceptionEndCatalog,
            DeliveryStartCatalog: this.vo.deliveryStartCatalog,
            DeliveryEndCatalog: this.vo.deliveryEndCatalog,
            DeliveryCycleDiv: this.vo.deliveryCycleDiv,
            MonthlyDeliveryTimes: this.vo.monthlyDeliveryTimes,
            GoodsCatalogDiv: this.vo.goodsCatalogDiv,
            PauseGroupCode: this.vo.pauseGroupCode,
            CoopCodes: this.vo.coopCodes,
          },
          combination: this.vo.detailInfoList.map(detail => ({
            parameter: {
              ApplicableStartCatalog: detail.applicableStartCatalog,
              ApplicableEndCatalog: detail.applicableEndCatalog,
              PauseDelivery: detail.pauseDelivery,
              DiscountType: detail.discountType,
              DiscountUnitPrice: detail.discountUnitPrice,
              DiscountRate: detail.discountRate,
              DiscountPrice: detail.discountPrice,
              RememberGoodsName: this.kymw00Model.deleteStartAndEndSpace(detail.rememberGoodsName),
              RememberGoodsNameKana: this.kymw00Model.deleteStartAndEndSpace(detail.rememberGoodsNameKana),
              RememberStandardName: this.kymw00Model.deleteStartAndEndSpace(detail.rememberStandardName),
              RememberStandardNameKana: this.kymw00Model.deleteStartAndEndSpace(detail.rememberStandardNameKana),
            }
          }))
        }
      }
    })
  }

  /**
   * API呼び出し
   * 
   * @param model 
   * @param vo 
   * @param successFunc 
   */
  execute(model: KYMW7402Model, vo: RememberGoodsInfoModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send( 'updateRememberGoodsInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   * @param data 
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}